import { render, staticRenderFns } from "./GiftCard.html?vue&type=template&id=3480dda5&scoped=true&"
import script from "./GiftCard.js?vue&type=script&lang=js&"
export * from "./GiftCard.js?vue&type=script&lang=js&"
import style0 from "./GiftCard.scss?vue&type=style&index=0&id=3480dda5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480dda5",
  null
  
)

export default component.exports